import React, { useState, useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../utils/firebase.js";

const BannerAd = () => {
  const [adsEnabled, setAdsEnabled] = useState(false);
  const [adsLoaded, setAdsLoaded] = useState(false);
  const [isUSUser, setIsUSUser] = useState(false);
  const [showAds, setShowAds] = useState(false);

  // Real-time Firestore listener
  useEffect(() => {
    const docRef = doc(db, "settings", "ads");
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const enabled = docSnap.data().enabled;
        console.log("BannerAd: Ads enabled status:", enabled);
        setAdsEnabled(enabled);
      }
    });

    return () => unsubscribe();
  }, []);

  // Detect user location
  useEffect(() => {
    const checkUserRegion = async () => {
      try {
        const response = await fetch("https://ipapi.co/country/");
        const countryCode = await response.text();
        console.log("BannerAd: User country detected:", countryCode);
        if (countryCode === "US") {
          setIsUSUser(true);
        }
      } catch (error) {
        console.error("BannerAd: Error detecting country:", error);
      }
    };

    checkUserRegion();
  }, []);

  // Show ad based on consent and location
  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    const allowAd = adsEnabled && (isUSUser || consent === "true");
    console.log("BannerAd: Consent check:", { adsEnabled, isUSUser, consent });

    if (allowAd) {
      setShowAds(true);
    }
  }, [adsEnabled, isUSUser]);

  // Trigger adsbygoogle only after visibility
  useEffect(() => {
    if (showAds && !adsLoaded) {
      try {
        console.log("BannerAd: Triggering adsbygoogle push...");
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        setAdsLoaded(true);
      } catch (error) {
        console.error("BannerAd: AdSense push error:", error);
      }
    }
  }, [showAds, adsLoaded]);

  if (!adsEnabled) return null;

  return (
    <div className="w-full flex justify-center">
      {showAds ? (
        <div className="w-full max-w-screen-lg bg-gray-200 dark:bg-gray-900 transition-colors duration-300 rounded-md">
          <ins
            className="adsbygoogle dark:bg-gray-900 bg-gray-200"
            style={{ display: "block", width: "100%" }}
            data-ad-client="ca-pub-4530213491042233"
            data-ad-slot="9624082539"
            data-ad-format="auto"
            data-full-width-responsive="true"
          ></ins>
        </div>
      ) : (
        <div className="w-full max-w-screen-lg bg-transparent"></div> // prevents layout shift without visual clutter
      )}
    </div>
  );
};

export default BannerAd;
